import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import { narsilApis } from '@flipster/apis/v1/dynamic-earn';
import { overlayBunja } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system/modal';

import { narsilTerms } from '../../main-page/misc/agree-checkbox';
import { NarsilOverviewQueryKey, narsilRedeemOverviewBunja } from '../state';
import { createRedeemModal } from './create-redeem-modal';

const { RedeemModalContent: NarsilRedeemModalContent, redeemModalBunja: narsilRedeemModalBunja } = createRedeemModal({
  redeemOverviewBunja: narsilRedeemOverviewBunja,
  previewApi: narsilApis.postRedeemPreview,
  confirmApi: narsilApis.postRedeemConfirm,
  overviewQueryKey: NarsilOverviewQueryKey,
  productName: 'Narsil USDT Prime',
  terms: narsilTerms,
  fromLabelId: 'Earn.r260601.From_narsil_usdt_prime',
});

export { NarsilRedeemModalContent, narsilRedeemModalBunja };

const openNrsusdtpRedeemModalBunja = bunja(() => {
  const overlay = bunja.use(overlayBunja);

  function openNrsusdtpRedeemModal() {
    overlay.open(({ isOpen, close, unmount }) => (
      <Modal.Root isOpen={isOpen} onClose={close} onExit={unmount}>
        <NarsilRedeemModalContent onClose={close} />
      </Modal.Root>
    ));
  }

  return { openNrsusdtpRedeemModal };
});
openNrsusdtpRedeemModalBunja.debugLabel = 'openNrsusdtpRedeemModalBunja';

export const useNrsusdtpRedeemModal = () => {
  const { openNrsusdtpRedeemModal } = useBunja(openNrsusdtpRedeemModalBunja);
  return openNrsusdtpRedeemModal;
};
